import { render, staticRenderFns } from "./sobre.vue?vue&type=template&id=2bb3e850&"
import script from "./sobre.vue?vue&type=script&lang=js&"
export * from "./sobre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports